export const levelConfig = {
  County: {
    level: 'County',
    table: 'county',
    tileUrl: '/tile/county/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: false,
  },
  Municipality: {
    level: 'Municipality',
    table: 'muni',
    tileUrl: '/tile/muni/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: false,
  },
  'MA Senate District': {
    level: 'MA Senate District',
    table: 'senatedist',
    tileUrl: '/tile/senatedist/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: true,
  },
  'MA House District': {
    level: 'MA House District',
    table: 'housedist',
    tileUrl: '/tile/housedist/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: true,
  },
  'Census Tract': {
    level: 'Census Tract',
    table: 'tract',
    tileUrl: '/tile/tract/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: false,
  },
  'Census Block': {
    level: 'Census Block',
    table: 'block',
    tileUrl: '/tile/block/{z}/{x}/{y}',
    geometryType: 'polygon',
    restricted: false,
  },
};
